import {LoadingIndicatorEventTypeEnum} from '../enum/loading-indicator-event-type.enum';

/**
 * @class
 * @description This class provides methods to interact with the loading-indicator indicator event.
 * @event
 * @export
 * @name LoadingIndicatorEvent
 */
export class LoadingIndicatorEvent {

  /**
   * @constructor
   * @description This method instantiates a new instance of our loading-indicator indicator event.
   * @memberof LoadingIndicatorEvent
   * @name LoadingIndicatorEvent#constructor
   * @param {LoadingIndicatorEventTypeEnum} type The type of event for the loading-indicator indicator.
   * @param {any} value The value associated with the loading-indicator indicator event.
   * @public
   */
  public constructor(
    /**
     * @description This property contains the type of event for the loading-indicator indicator.
     * @memberof LoadingIndicatorEvent
     * @name LoadingIndicatorEvent#type
     * @public
     * @property
     * @type {LoadingIndicatorEventTypeEnum}
     */
    public type: LoadingIndicatorEventTypeEnum,
    /**
     * @description This property contains the value associated with the loading-indicator indicator event.
     * @memberof LoadingIndicatorEvent
     * @name LoadingIndicatorEvent#value
     * @public
     * @property
     * @type {number | Error | undefined}
     */
    public value?: number | Error | undefined) {
  }
}
